import React from 'react'
import { PaymentFormProps } from '../../../../../../Types/FormType'
import { Col, FormGroup, Input, Label } from 'reactstrap'
import { Image, P } from '../../../../../../AbstractElements'
import { Paypal } from '../../../../../../Utils/Constants'
import { dynamicImage } from '../../../../../../Utils'

export default function PayPalOption({ payMethod, updateFormData }: PaymentFormProps) {
    return (
        <Col xs={12}>
            <div className="card-wrapper border rounded-3 light-card">
                <div>
                    <FormGroup check className="radio radio-primary">
                        <Input id="shipping-choose5" type="radio" name="paymentMethodName" value="Paypal" checked={payMethod === "Paypal"} onChange={updateFormData} />
                        <Label className="mb-0 f-w-500" htmlFor="shipping-choose5" check>{Paypal}</Label>
                    </FormGroup>
                    <P>{"You will be taken to the paypal website to finish your transaction safely"}</P>
                </div>
                <div>
                    <Image src={dynamicImage(`checkout/paypal.png`)} alt="paypal" />
                </div>
            </div>
        </Col>
    )
}
